import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import styled from 'styled-components';
const Wrapper = styled.div `
  display: block;
  user-select: none;
  margin-top: 40px;
  width: 100%;
  overflow: hidden;

  &[data-variant='white'] ul li {
    a,
    span {
      --colorFg: ${brand.white};
      --colorBorder: ${brand.white};

      --colorFgActive: ${brand.base.blue};
      --colorBgActive: ${brand.white};
      --colorBorderActive: ${brand.white};

      --colorFgComplete: ${brand.base.blue};
      --colorBgComplete: ${brand.white};
    }
  }

  ul {
    display: flex;
    flex-direction: row;
    place-content: center;
    place-items: center;
    width: 100%;

    li {
      ${transition('opacity')};

      display: inline-block;
      opacity: 1;
      padding: 0 6px;

      @media ${until(Device.Tablet)} {
        padding: 0 8px;
      }

      &:nth-child(2) {
        @media ${until(Device.Tablet)} {
          flex: 1 1 25%;
          display: flex;
          justify-content: flex-end;
        }
      }

      &:nth-last-child(2) {
        @media ${until(Device.Tablet)} {
          flex: 1 1 25%;
        }
      }

      a,
      span {
        ${transition('background-size, border-color, opacity')};
        ${fonts.apparat.semiBold};

        --borderWidth: 2px;

        --bgSize: 0% 100%;
        --colorFg: ${brand.primary.blue};
        --colorBg: transparent;
        --colorBorder: ${brand.primary.blue};

        --bgSizeActive: 100% 100%;
        --colorFgActive: ${brand.white};
        --colorBgActive: ${brand.primary.blue};
        --colorBorderActive: ${brand.primary.blue};

        --colorFgComplete: ${brand.white};
        --colorBgComplete: ${brand.base.blue};

        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: var(--borderWidth, 0) solid var(--colorBorder, var(--colorBg));
        border-radius: ${fluid(24, 50)};
        background: var(--colorBg);
        background-image: linear-gradient(to right, var(--colorBgActive), var(--colorBgActive));
        background-repeat: no-repeat;
        background-size: var(--bgSize);
        color: var(--colorFg);
        height: ${fluid(40, 50)};
        text-decoration: none;
        user-select: none;
        width: ${fluid(40, 50)};
        position: relative;
        background-position: left center;
        font-size: ${fluid(16, 18)};
      }

      a {
        /* Mobile click styles - button should mimic press */
        @media ${until(Device.TabletLarge)} {
          ${transition('color, background-color, border-color, transform')};
          &:active {
            transform: translateY(1.5px);
          }
        }

        @supports selector(:focus-visible) {
          &:focus-visible {
            outline: auto;
            outline-offset: 3px;
            outline-width: 2px;
            outline-style: solid;
          }

          &:hover {
            border-color: var(--colorBorderActive, var(--colorBgActive));
            color: var(--colorFgActive);
            background-size: var(--bgSizeActive);
          }

          &:active {
            outline: none;
            color: var(--colorFgComplete);
            background: var(--colorBgComplete);
          }
        }

        @supports not selector(:focus-visible) {
          &:focus {
            outline: none;
          }

          &:focus {
            outline: auto;
            outline-offset: 3px;
            outline-width: 2px;
            outline-style: solid;
          }

          &:hover {
            border-color: var(--colorBorderActive, var(--colorBgActive));
            color: var(--colorFgActive);
            background-size: var(--bgSizeActive);
          }

          &:active {
            outline: none;
            color: var(--colorFgComplete);
            background: var(--colorBgComplete);
          }
        }
      }

      &.previous,
      &.next {
        @media ${until(Device.Tablet)} {
          flex: 1 0 50%;
          display: flex;
        }

        a {
          display: flex;
          border: none;
          background-color: transparent;
          color: var(--fgColour);
          border-radius: 5000px;

          &::after {
            content: none;
          }
        }
      }

      &.previous {
        transform: scaleX(-1);
        padding-left: 6px;
        padding-right: 6px;
      }

      &.next {
        padding-right: 0px;
        padding-left: 6px;
      }

      &.break {
        a {
          pointer-events: none;
        }
      }

      &.selected {
        a {
          color: var(--colorFgComplete);
          background: var(--colorBgComplete);
        }
      }

      &.disabled {
        cursor: default;
        opacity: 0.5;
        pointer-events: none;
      }
    }

    ${ButtonStyles.IconWrapper} svg {
      transform: none;
    }
  }
`;
export default {
    Wrapper,
};
